module.exports = __webpack_public_path__ + "img/icon-eth-blocks-logo.e07b6c5e.png";